import { isMobileBrowser } from '../base/environment/utils';
// [REMOVED: jaas] import { isVpaasMeeting } from '../jaas/functions';
import EmbedMeetingButton from './components/EmbedMeetingButton';
const embed = {
    key: 'embedmeeting',
    Content: EmbedMeetingButton,
    group: 4
};
/**
 * A hook that returns the embed button if it is enabled and undefined otherwise.
 *
 *  @returns {Object | undefined}
 */
export function useEmbedButton() {
    // [REMOVED: jaas] isVpaasMeeting check removed — embed always available on desktop
    if (!isMobileBrowser()) {
        return embed;
    }
}
